<template>
  <div class="mw-panel">
    <div class="mw-panel" style="position: relative;" :class="{'flow-area-on-top':((type==='module_flow' || isCheck || normalFlowBtn) && flowActionPosition==='top')}">
      <div class="mw-open-form " :style="{height:(type==='module_flow' && processDefinitionId || normalFlowBtn) && editMode && isBottonArea?'calc(100% - '+(flowAreaBottomSelRowHeight+50)+'px)':((type==='module_flow' || isCheck || normalFlowBtn) && isTopArea?'calc(100% - 50px)':'100%')}"
           :class="{'mw-normal-form_layout':(type==='module_normal' && !normalFlowBtn || isBottonArea)?true:false,'mw-read-only-form':(!editMode && !isTopArea)}">
        <div class="mw-form-left-con">
          <div class="mw-form-left">
            <div class="__body">
              <div class="mw-form_id"></div>
            </div>
          </div>
          <div class="mw-form-right-con" v-if="(type=='module_flow' || normalFlowBtn) && editMode && !isVerticalArea">
            <template v-if="rightCustomCompId">
              <div ref="rightCustomCompDiv" style="width: 100%;height: 100%;">
              </div>
            </template>
            <template v-else>
            <div class="comment">
              <div class="comment-tip">{{$lang("常用意见")}}
                <el-button @click="editComment()">{{$lang("编辑常用意见")}}</el-button>
              </div>
              <div class="comment-list">
                <div v-for="(c, index) in comments" :key="index">
                  <a @click="selComment(c.title)" v-text="c.title"></a>
                </div>
              </div>
              <template v-if="extCustomCommentCompId">
                <div ref="extCustomCommentRef"></div>
              </template>
              <div class="comment-tip">{{$lang("填写意见")}}
                <el-button @click="addComment()">{{$lang("添加到常用意见")}}</el-button>
              </div>
              <div class="comment-sub">
                <textarea rows="5" style="border: 1px solid #9e9e9e;width: 100%;" v-model="comment"
                          :placeholder="$lang('请输入或选择常用意见')"
                          :disabled="disabledComment">
                  </textarea>
              </div>
            </div>
            <div class="form-btn">
              <el-button type="primary" :key="button.action" :loading="button.loading" v-for="button in buttons"
                         @click="_doAction(button.action)">{{button.name}}
              </el-button>
            </div>
            <div class="flow-form-tip" v-if="type=='module_flow'">
              <div class="title">{{$lang('当前节点')}}</div>
              <div style="padding-left: 50px;">
                <ul><li>
                  <span ondragstart="return false;"  class="path_btn_style" href="#"><span >{{$lang(curTackName)}}</span></span>
                </li></ul>
              </div>
              <div class="title" v-if="!notLoadFlows">{{$lang("提交流转")}}</div>
              <div class="path_list" v-if="!notLoadFlows">
                <div class="path_fix_ico">{{$lang('送达')}}</div>
                <ul class="path_btn">
                  <li :class="flows.length===1 ? '': index===0 ? 'top': index===flows.length-1 ? 'bottom': ''" v-for="(f,index) in flows">
                    <span class="path_btn_style" ondragstart="return false;" href="#"><span>{{transFlowName(f.name)}}</span></span>
                  </li>
                </ul>
              </div>
            </div>
            </template>
          </div>
          <div class="mw-form-right-con split-right-con" ref="rightComment" v-if="(type=='module_flow' || normalFlowBtn)  && isTopArea">
            <iframe style="border: 0px currentColor;left:-8px; width: 100%; height: 100%; position: absolute; z-index: 0;"></iframe>
            <div class="right_panel_btn right-sidebar-toggle" @click="sidebarBtn"></div>
            <div class="comment" style="position: relative;">
              <div v-if="editMode" class="comment-tip" >
                <span style="color: black;font-weight: 600;">{{$lang("填写意见")}}</span>
                <el-button style="float: right;right:88px;" type="default" title="编辑常用意见" @click="editComment()"><i class="fa fa-cog"></i></el-button>
                <el-dropdown v-show="showSelComment" style="float: right;" @command="selComment" @click="selComment">
                  <el-button type="default" style="position: inherit;" >
                    常用意见<i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item  v-for="(c, index) in comments" :command="c.title" :key="index">{{c.title}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

              </div>
              <div v-if="editMode" class="comment-sub" style="margin-bottom: 10px;">

                 <textarea rows="5" style="border: 1px solid #9e9e9e;width: 100%;" v-model="comment"
                           :placeholder="$lang('请输入或选择常用意见')"
                           :disabled="disabledComment">
                  </textarea>

              </div>
              <div class="flowComment"  style="margin-bottom: 10px;">
                <el-tabs type="border-card">
                  <el-tab-pane>
                    <span slot="label">批示意见汇总</span>
                    <div :style="{height:fjheight,overflow:'auto'}" class="list_normal">
                      <ul class="down_table_list_text">
                        <li v-for="(c, index) in Array.prototype.reverse.call(taskComments)" :key="index">
                          <dl class="down_other_file">
                            <dd>
                              <div class="file_tips">{{c.content}}</div>
                              <div class="file_title" style="padding-bottom: 0px;font-size: 12px;">
                                <span class="date" style="">{{moment(c.createTime).format("MM-DD HH:mm")}}</span>
                              {{c.department+':'+c.creator}}</div>
                            </dd>
                          </dl>
                        </li>
                      </ul>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div class="flowAttachment">
                <el-tabs type="border-card">
                  <el-tab-pane>
                    <span slot="label">查看附件</span>
                    <div :style="{height:fjheight,overflow:'auto'}" class="list_normal">
                      <ul class="down_table_list_text">
                        <li v-for="(c, index) in attachmentData" :key="index">
                          <dl class="down_other_file">
                            <dd>
                              <div class="file_title"><a href="#" @click="downAttachment(c.id)">{{c.name}}</a></div>
                              <div class="file_tips_info">{{c.creator+' '+moment(c.createTime).format("MM-DD HH:mm")}}</div>
                            </dd>
                          </dl>
                        </li>
                      </ul>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
      <flow-action-area class="vertical-flow-area" ref="footerArea" :height="(flowAreaBottomSelRowHeight+50)+'px'" :form="this" v-if="(type==='module_flow' && processDefinitionId || normalFlowBtn ) && editMode && isBottonArea"></flow-action-area>
      <flow-action-top-area class="vertical-flow-area" ref="footerArea" height="50px" :form="this" :buttons="buttons" v-if="(type==='module_flow' || normalFlowBtn || isCheck ) && isTopArea"></flow-action-top-area>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash';
  import {errMessage} from 'common/util';
  import Vue from 'vue';
  import {mapGetters} from 'vuex'
  import './action';
  import formExpContext from "./formExpContext";
  import * as bpmTaskApi from '@/common/api/bpm-task';

  import ResourceLock from '@/common/utils/resourceLock'

  import flowActionArea from './flow-action-area'
  import flowActionTopArea from './flow-action-top-area'
  export default {
    name: 'MwForm',
    components:{
      "flow-action-area":flowActionArea,
      "flow-action-top-area":flowActionTopArea
    },
    data() {
      let me = this, commentId = $uuid();
      let pos= window.$Env && $Env.formFlowAreaPosition || "right"; //"right/bottom/top"
      let rightCustomCompId = window.$Env && $Env.formRightCustomCompId || ""; ;
      return {
        flowActionPosition:pos,
        rightCustomCompId:rightCustomCompId,
        formValueChange: false,
        editMode: me.propEditMode,
        footerButton: [],
        action: '',
        taskComments:[],
        $newForm: undefined,
        commentComponent: [],
        $commentMinComponent: [],
        components: [],
        flowAreaBottomSelRowHeight:34,
        createTime: '',
        type: '',
        taskId: '',
        batchId:'',
        businessId: '',
        draftsDocId:'',
        flowStarted:false,
        formId: '',
        formKey: '',
        formVersion: '',
        formName: '',
        processDefinitionId: '',
        processDefinitionName: '',
        activityId: '',
        tempBusinessId: '',
        tempTableName:'',
        authFields:undefined,
        extCustomCommentCompId:'',
        // manually update it when need.
        form: {
          data: null,
          ver: 1,
        },
        activity: undefined,
        buttons: [],
        notLoadFlows:(window.$Env && window.$Env.formNotLoadFlows),
        flows:[],
        curTackName:"",
        comments: [],

        comment: '',
        commentId: commentId,
        isUpdateComment:false,
        commentCategory: '',

        /*currentAction: null,*/
        fieldMapping: {},

        moduleId: '',
        appId: '',
        flowKey: '',
        //params:{},

        attachmentData: [],
        taskData: [],

        loaded: false,
        counter: 0,
        formOpenSource: '',

        extData:undefined,

        /**
         * @author wong
         * @type {{fldWhSerialNumber?: string, fldWhYear?: string, fldWhFileWordId?:string,fldWhFildWordName?:string}}
         * @desc 文号控件输出数据保存到表单数据里, 流水号、年度、文件字控件本身可固定域名。
         */
        extraFormField: {},
        formCustomComps:{},
        lockSuccess:true,
        lockErrorMsg:"",
        normalFlowBtn:false,
        fjheight:'110px',
        showSelComment:true,
        disabledComment:false,
        showRightComment:false,
      }
    },
    props: {
      dialog: Object,
      initValue: {
        type: Object,
        default: function () {
          return {};
        }
      },
      propLoading:{
        type: Object
      },
      extParams:{
        type: Object,
        default: function () {
          return {};
        }
      },
      /* propType: {
         type: String,
         default: 'flow'
       },*/
      autoClaim:{ //是否自动签收
        type: Boolean,
        default: true
      },
      forceModuleForm:{ //是否强制使用模块的表单打开
        type: Boolean,
        default: false
      },
      flowModuleNotShowRightPanel:{
        type: Boolean,
        default: false
      },
      propReadOnly:{
        type: Boolean,
        default: false
      },
      propModuleId: String,
      propAppId: String,
      propIsCheck: {
        type: Boolean,
        default: false
      },//关注表单标志
      propCheckFromName: String,//关注表单标题
      propFlowKey: String,
      propTaskId: String,
      propBusinessId: String,
      propDraftsDeptId:String, //起草部门Id
      propDraftsDocId:String,//起草文档ID
      propBatchId: String,
      propTempBusinessId: String,
      propTempTableName: String,
      propProcessDefinitionId:String,
      propEditMode: {
        type: Boolean,
        default: true
      },
      propFormOpenSource: String,
      openType:String,//nativeWin是浏览器窗口打开
    },
    created() {
      this.taskId = this.propTaskId;
      this.batchId = this.propBatchId;
      this.businessId = this.propBusinessId;
      this.draftsDocId=this.propDraftsDocId
      this.moduleId = this.propModuleId;
      this.appId = this.propAppId;
      this.flowKey = this.propFlowKey;
      this.isCheck = this.propIsCheck;
      this.checkFromName=this.propCheckFromName;
      if (!this.businessId) {
        if (this.propTempBusinessId) {
          this.tempBusinessId = this.propTempBusinessId;
        } else {
          this.tempBusinessId = $uuid();
        }
        if (this.propTempTableName){
          this.tempTableName=this.propTempTableName;
        }
     } else {
        this.tempBusinessId = '';
      }
      this.formOpenSource = this.propFormOpenSource;
    },
    mounted() {
      //scriptAction();
      var me = this;
      if(this.isTopArea){
        if(this.batchId){
          this.mwApi.business.listComment({batchId:this.batchId,"excludeHidden":'2'}).then(function(res){
            res = res.result?res.result:res;
            me.taskComments = res;
          })
        }
        this.$nextTick(function(){
          $(".mw-open-form .mw-form-left-con").css("overflow-y","inherit").css("padding-right","0px");
          $("html").css("overflow-y","hidden");
        })
      }
      this.renderForm();
    },
    beforeDestroy() {
      try {
        this.$newForm.destroy();
      } catch (e) {
      }
    },
    computed: {
      ...mapGetters([
        'expUser',
        'userInfo',
        'initInfo'
      ]),
      isVerticalArea(){
        return this.flowActionPosition==="top" || this.flowActionPosition==="bottom"
      },
      isBottonArea(){
        return this.flowActionPosition==="bottom";
      },
      isTopArea(){
        return this.flowActionPosition==="top";
      }
    },
    methods: {
      downAttachment(id){
        if(!id) return;
        var formId = this.formId;
        var businessId = this.tempBusinessId || this.businessId;
        if(!businessId||!formId){
          return ;
        }
        if(window.$Env && $Env.notdownloadAttachment){
            var p = {
                "id":id,
                "businessId": businessId,
                "formId": formId,
                "tempBusinessId": this.tempBusinessId
            }
            PF.action.attachment_preview(p);
        }else{
            this.mwUtil.downloadAttachment2({
            url: `/api/business/downloadAttachment`,
            params: {
                "id":id,
                "businessId": businessId,
                "formId": formId,
                "tempBusinessId": this.tempBusinessId
            }
            });
        }
      },
      refleshAttachmentList(formId_,businessId_,tempBusinessId_){
        var me = this;
        var formId = formId_||this.formId;
        var businessId = businessId_||this.businessId;
        var tempBusinessId = tempBusinessId_?tempBusinessId_:"";
        if((!businessId && !tempBusinessId) || !formId){
          return ;
        }
        this.mwApi.business.listAttachment({"businessId":businessId,"formId":formId,"type":"JOA_FJ","tempBusinessId":tempBusinessId}).then(function(res){
            me.attachmentData = res.result;
        });
      },
      getFormValueChange() {
        //return this.formValueChange;
        return !this.$newForm || this.$newForm.isDirty();
      },
      setEditMode(editMode) {
        let me = this;
        if(me.editMode===editMode)return;
        let formValues;
        if (me.$newForm) {
          formValues=me.$newForm.getValue();
          me.$newForm.destroy();
          me.$newForm = undefined;
        }

        this.mwLodash.remove(me.footerButton, function (n) {
          return true;
        });


        me.editMode = editMode;
        me.renderFormContent();
        if (formValues) {
          me.$once("beforeRender", () => {
            $(this.$el.querySelector('.mw-form_id')).empty();
            me.$nextTick(() => {
              me.$newForm.setValue(formValues);
            });
          });
        }
      },
      editComment() {
        let params = {}
        params.comment = this.comments.slice();
        PF.show('commentEdit', params, this._comment);
      },

      addComment() {
        let a = [], me = this
        let c = me.comment.replace(/\n/g, '');
        if (c == '') {
          return;
        }
        this.comments.push({'title': c})
        this.comments.forEach(function (d) {
          a.push(d.title)
        })
        me.mwApi.org.updateUserInfo({options: a.join('\n')}).then(function () {
          me.$store.dispatch('GetUserInfo')
        })
      },
      _comment(data) {
        let a = [], me = this
        data.forEach(function (d) {
          a.push(d.title)
        })
        me.mwApi.org.updateUserInfo({options: a.join('\n')}).then(function () {
          me.$store.dispatch('GetUserInfo')
        })
        this.comments = data
      },


      //选择意见
      selComment(title) {
        this.comment = title;
      },
      resetForm() {
        this.formName = '';
        this.buttons = [];
        this.comments = [];
        this.comment = '';
        if (this.$newForm) {
          this.$newForm.destroy();
          this.$newForm = undefined;
        }
        this.components = [];
        this.commentComponent = [];
        this.$commentMinComponent = [];
        $(this.$el.querySelector('.mw-form_id')).empty();
      },

      renderForm() {
        let me = this;
        if (me.moduleId) {

          if (me.taskId) {
            me.mwApi.process.getTaskEntityData(me.taskId).then((data) => {
              me.taskData = data.result
              me.processDefinitionId = me.taskData.processDefinitionId;//processDefinitionId undefined
              me.activityId = me.taskData.activityId;
              if (!me.taskData.claimTime && !me.taskData.finishTime && me.autoClaim) { //自动签收
                let claimParams = {};
                if(me.extParams && me.extParams.fullAuthType){
                  claimParams.fullAuthType = me.extParams.fullAuthType;
                }
                me.mwApi.process.claim(me.taskId,claimParams).then(res => {
                  me.$emit("updatedData", true);
                  //若启用秘书代办子流程则切换成子流程任务ID add by stt 20180601
                  if (res && res.result && res.result.startTaskId) {
                    me.taskId = res.result.startTaskId;
                    me.mwApi.process.getTaskEntityData(me.taskId).then((data) => {
                      me.taskData = data.result
                      me.processDefinitionId = me.taskData.processDefinitionId;
                      me.activityId = me.taskData.activityId;
                      me.renderTaskForm(me.taskData);
                    });
                  } else {
                    me.renderTaskForm(me.taskData);
                  }
                });
              } else {
                me.renderTaskForm(me.taskData);
              }
            });
          } else {
            if(me.propProcessDefinitionId){
              me.processDefinitionId =me.propProcessDefinitionId;
            }else{
              me.processDefinitionId="";
            }
            me.activityId = '';
            me.renderStartForm();//没有taskId调用的是这里
          }

        } else {
          me.resetForm();
        }
      },
      updateAccessTime(){
        let me = this;
        if(window.$Env && $Env.openFormUpdateAccessTime && me.type == 'module_flow' && me.batchId){
          let params = {batchId:me.batchId};
          if(me.extParams && me.extParams.fullAuthType){
            params.fullAuthType = me.extParams.fullAuthType;
          }
          me.mwApi.process.updateAccessTime(params);
        }
      },
      renderStartForm() { //开始起草表单
        var me = this;
        //me.renderConfig();
        if(me.type!='module_normal') {
          me.renderComments();
        }
        me.renderFormContent(true);
      },
      renderTaskForm(t) { //任务表单
        var me = this;
        if (t.finishTime || t.suspensionState == 2) {
          me.editMode = false;
          me.renderFormContent(false);
        } else {
          me.normalFlowBtn=true;
          if(!me.flowModuleNotShowRightPanel){
            me.editMode = true;
          }
          me.renderFormContent(true);
          // me.renderConfig();
          if(me.type!='module_normal') {
            me.renderComments();
          }
        }
      },
      renderTaskFormFlowTip(callback){
        var me = this;
        if(me.type==='module_normal'){
          return;
        }
        if(me.taskId){
          let params = {taskId:me.taskId};
          if(me.$newForm) {
            me.$newForm.fireEvent("rendertaskformflow", params);
          }
          if(me.notLoadFlows) {
            if(callback)callback(me.flows);
            return
          }
          bpmTaskApi.getTaskFlow(params).then(data=>{
            if(data){
              me.flows = data;
              if(callback)callback(me.flows);
            }
          })
        }else{
          if(me.processDefinitionId) {
            PF.ajax("api/process/getStartFlows",{processDefinitionId:me.processDefinitionId}).then((data) => {
              if(data.result)
                me.flows = data.result;
              if(callback)callback(me.flows);
            });
          }
        }
      },
      renderComments() {
        let me = this;
        let option = me.userInfo.data.options
        if (option == undefined) {
          me.comments = []
        } else {
          let options = option.split('\n');
          options.forEach(function (v) {
            me.comments.push({title: v})
          })
        }
      },
      renderFormContent(flowFlag) {
        let me = this;
        let params = {};
        if(me.businessId){
          params.dataId=me.businessId;
        }else{
          let tempId = ""
          if (this.propTempBusinessId) {
            tempId = "_" + this.tempBusinessId;
          }
          params.dataId=tempId;
          if(me.tempTableName){
            params.tempTableName=me.tempTableName;
          }
        }

        params.taskId = me.taskId;
        if (me.taskId) {
          params.processDefinitionId = me.processDefinitionId;
          params.activityId = me.activityId;
        }
        params.processDefinitionKey = me.flowKey;
        params.flowFlag=flowFlag==undefined?true:flowFlag;
        params.forceModuleForm=me.forceModuleForm;
        params.normalFlowBtn=me.normalFlowBtn;
        params.moduleId=me.moduleId;
        params.appId=me.appId;
        params.draftsDocId=me.draftsDocId;
        params.formOpenSource = me.formOpenSource;
        params.taskType=me.taskData && me.taskData.type;
        params.propReadOnly=me.propReadOnly;
        //是否需要锁定编辑
        if(params.taskId && params.dataId && !me.propReadOnly && !(window.$Env && $Env.notOpenDocLockEditMode)){
          params.tryLockEditMode = "1";
        }
        me.mwApi.config.moduleConfig(params).then((data) => {
          let res = data.result;
          me.formId = res.formId;
          let resId=res.formData && res.formData.id;
          if (resId && res.attr && res.attr.set && res.attr.set.savereadmarks) {
            PF.fsrv('read.state.markRead',{resId:resId,userId:me.expUser.id,formId:res.formId})
          }
          if(res.lockSuccess===true){
            //取得了锁，定时去更新
            let lock=new ResourceLock({resourceId:params.dataId,resTableName:me.formId,docName:res.formData.fldtm,initunitid:res.formData.initunitid});
            lock.updateLock();
            me.$on("formActionComplete",()=>lock.unlock());
            me.$on("dialogClose",()=>lock.unlock());
          }else if (res.lockSuccess === false) {
            me.lockSuccess = false;
            me.lockErrorMsg = res.lockErrorMsg;
            me.readOnly=true;
          }else{
            //不需要锁。
          }
          me.$emit("configLoaded",res);
          me.appId=res.appId;
          me.formVersion = res.formVersion;
          me.formKey = res.formKey;
          me.formName = res.name;
          me.moduleShortName = res.shortName;
          if(window.$Env && $Env.formFlowBottomAreaModules && $Env.formFlowBottomAreaModules.indexOf(me.moduleShortName) != -1){
            me.flowActionPosition = "bottom";
          }
          me.type = res.type;
          //如果是流程表单，传了businessId但是没有taskId的话，不能编辑
          //hg新浏览器打开在异常处理里需要显示办理界面me.propEditMode !== "true"
          if(!me.taskId && me.type==="module_flow" && me.businessId && me.propEditMode !== "true"){
              me.editMode=false;
              me.readOnly=true;
          }
          me.createTime = res.createTime;
          if(me.editMode)
            me.authFields=res.authFields;
          else
            me.authFields={};
          me.extData=res.extData;
          if (res.attr && res.attr.fieldMapping) {
            me.fieldMapping = res.attr.fieldMapping;
          }
          if(res.draftsDocId!=undefined){
            me.businessId=res.draftsDocId;
          }
          if(res.tempDraftsDocId!=undefined){
            me.tempBusinessId=res.tempDraftsDocId;
          }
          if(res.flowStarted!=undefined){
            me.flowStarted=res.flowStarted;
          }
          let formData = res.formData;
          if(formData){
            //若打开表单未指定流程批次则取表单初始化流程批次
            if(!me.batchId && formData.initbatchid){
              me.batchId=formData.initbatchid;
            }
            //若打开表单未指定流程定义ID则取表单初始化流程定义ID
            if(!me.processDefinitionId && formData.initprocdefid){
              me.processDefinitionId=formData.initprocdefid;
            }
            //附件列表
            if (res.formData && res.formData['#items']) {
              let attachment = [];
              res.formData['#items'].forEach(v => {
                if (v.type == "JOA_FJ") {
                  attachment.push(v);
                }
              })
              me.attachmentData = attachment;

            }
            me.updateAccessTime();
          }
          if(!me.businessId){
            if (!formData) {
              formData = {};
            } else {
              delete formData.id;
            }
          }
          if(data.result.activity){
            me.activity = data.result.activity;
            me.processDefinitionId = me.activity.processDefinitionId;
            me.flowKey = me.activity.processDefinitionKey;
            me.processDefinitionName = me.activity.processDefinitionName;
            me.curTackName = me.activity.name;
            me.renderDefaultComment();
          }
          if(data.result.components){
            let c = data.result.components;
            c.forEach(function (v) {
              //if (v.type == 'button') {
              v.loading=false;
              v.name=$lang(v.name);
              me.buttons.push(v);
              //}
            });
          }
          me.$nextTick(() => {
            me._originalFormData = formData;
            me._renderForm(res.content,formData);
            if(this.isTopArea){
                let cutHeight = 215+60;
                if(!me.editMode) cutHeight = 110;
                let fjheight = ($(".mw-open-form .mw-form-right-con").height()-cutHeight)/2;
                if(fjheight<80){
                  this.fjheight = 80+'px';
                }else{
                  this.fjheight = fjheight+'px';
                }
            }
            if(me.activity && !me.isVerticalArea){
              me.renderTaskFormFlowTip(function () {
                if(me.rightCustomCompId) me.processRightCustomComp();
              });
            }
            if(me.$newForm){
              me.$newForm.refleshAttachmentList = me.refleshAttachmentList;
            }
          });
        }).catch(msg => {
          if(window.console)window.console.log(msg);
        });
      },

      _renderForm(con, value) {
        let me = this;
        let formValue;
        let initInfo=_.pickBy(me.initInfo,(v,k)=>_.startsWith(k,"init"));
        if (this.businessId) {
          if(!value){
            if (me.type == 'module_normal') {
              formValue = me.mwLodash.assign({initcreatedtime: me.createTime, initappid: me.appId}, initInfo,me.initValue, {id: this.businessId})
            }
          }else{
            formValue=value;
          }
        } else {
          let flow={};
          if(me.type=='module_flow'){
            flow.initflowid=me.processDefinitionId;
            flow.initflowkey=me.flowKey;
            flow.moduleId=me.moduleId;
            flow.initflowname=me.processDefinitionName;
          }else{
            flow.moduleId=me.moduleId;
          }
          if(me.forceModuleForm){
            formValue = me.mwLodash.assign(value,{initcreatedtime: me.createTime, initappid: me.appId},flow, initInfo,me.initValue)
          }else{
            formValue = me.mwLodash.assign({initcreatedtime: me.createTime, initappid: me.appId},flow, initInfo,me.initValue, value)
          }
        }

        function fnImbeddedObjResolver(objId) {
          return new (function (formField) {
            var value = [];
            var component;
            var $data;
            var $obj;
            PF.apply(this, {
              init: function (d,obj) {
                $data = d;
                $obj=obj;
              },
              mount: function (fnMount) {
                var html;
                let config = Object.assign({
                  expUser: me.expUser,
                  getForm:function(){
                    return me.$newForm;
                  },
                  getCurrentObject:function(){
                    return $obj
                  },
                  $previewMode: false,
                  getFormValue: function () {
                    return me.formData();
                  },
                  getConfig: function () {
                    return $data;
                  },
                  getData: function () {
                    return {
                      businessId: me.businessId,
                      tempBusinessId: me.tempBusinessId,
                      formKey: me.formKey,
                      formId: me.formId,
                      formVersion: me.formVersion
                    }
                  },
                  getFormObject: function () {
                    return me;
                  }
                });

                switch (objId) {
                  case 'attachment-list': {
                    component = new (Vue.component('form-attachment-list'))({params: me._data, config: config});
                    fnMount(component.$mount().$el);
                    break;
                  }
                  case 'attachment-list-min': {
                    component = new (Vue.component('form-attachment-list-min'))({params: me._data, config: config});
                    fnMount(component.$mount().$el);
                    break;
                  }
                  case 'document-editor': {
                    component = new (Vue.component('form-document-editor'))({params: me._data, config: config});
                    fnMount(component.$mount().$el);
                    break;
                  }
                  case 'zw-attachment-list': {
                    component = new (Vue.component('form-zw-attachment-list'))({params: me._data, config: config});
                    fnMount(component.$mount().$el);
                    break;
                  }
                  case 'comment-list': {
                    component = new (Vue.component('form-comment-list'))({params: me._data, config: config});
                    fnMount(component.$mount().$el);
                    break;
                  }
                  case 'comment-list-min': {
                    component = new (Vue.component('form-comment-list-min'))({params: me._data, config: config});
                    fnMount(component.$mount().$el);
                    break;
                  }
                  case 'imbedded-view': {
                    component = new (Vue.component('form-imbedded-view'))({params: me._data, config: config});
                    fnMount(component.$mount().$el);
                    break;
                  }
                  case 'rel-file-selection': {
                    component = new (Vue.component('form-rel-file-selection'))({params: me._data, config: config});
                    fnMount(component.$mount().$el);
                    break;
                  }
                  default:{
                    if($data.pageType==="page"){
                      component=PF.createVue({
                        template:"<mw-inner-page :pageId='pageId' noWrap :params='params'></mw-inner-page>",
                        data:{
                          pageId:objId,
                          params:{data:me._data,config:config}
                        }
                      });
                      fnMount(component.$mount().$el);
                    }else if($data.pageType==="pageData" && $obj.getPageData){
                      let pageData=$obj.getPageData();
                      pageData.params={data:me._data,config:config};
                      component=PF.createVue(pageData);
                      if($obj.$dd.name){
                          me.formCustomComps[$obj.$dd.name] = component
                      }
                      fnMount(component.$mount().$el);
                    }
                  }
                }
                if (objId == 'comment-list') {
                  me.commentComponent.push(component);
                }
                if (objId == 'comment-list-min') {
                  me.$commentMinComponent.push(component);
                }
                if(component)me.components.push(component);
                if (html) {
                  fnMount($('<div>' + html + '</div>'));
                }
                return component;
              },
              onEvent: function (args) {
                if (component) {
                  if (component.dealWithEvent) {
                    component.dealWithEvent(args);
                  }
                } else {
                  if (args.dd.viewId && args.data.id) {
                    me.mwApi.app.getApplicationItems([args.dd.viewId], "").then((res) => {
                      let mixId = res.result[0].content.table.moduleId;
                      if (mixId) {
                        let me = this;
                        let p = {};
                        p.businessId = args.data.id;
                        p.moduleId = mixId;
                        p.size = 'large_large'
                        p.type = 'normal'
                        p.editMode = me.editMode;
                        p.appId = '';
                        PF.show('normalForm', p, function () {
                        });
                      }
                    })
                    //viewId
                  }
                }
              },
              setValue: function (value) {
                //console.log(value);
              },
              getValue: function () {
                //return value;
              },
              setReadOnly: function () {
              },
              destroy: function () {
                try {
                if (component)
                  component.$destroy();
                }catch(e){
                  if(window.console && console.error) console.error(e);
                }
              },
              show: function (ops) {

                let config = Object.assign({
                  expUser: me.expUser,
                  getForm:function(){
                    return me.$newForm;
                  },
                  getCurrentObject:function(){
                    return $obj
                  },
                  $previewMode: false,
                  getFormValue: function () {
                    return me.formData();
                  }, getConfig: function () {
                    return $data;
                  }, getData: function () {
                    return {
                      businessId: me.businessId,
                      tempBusinessId: me.tempBusinessId,
                      draftsDocId: me.draftsDocId,
                      formKey: me.formKey,
                      formId: me.formId,
                      formVersion: me.formVersion
                    }
                  }, getFormObject: function () {
                    return me;
                  }
                });

                switch (objId) {
                  case 'department-selection': {
                    var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                    PF.show('orgSelect', {multiple: multiple, config: config, value: ops.getValue()}, function (data) {
                        ops.setValue(data);
                        me.$newForm.fireEvent("afterorgSelect",data,$obj);
                    });
                    break;
                  }
                  case 'user-selection': {
                    var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                    PF.show('orgSelect', {multiple: multiple, config: config, value: ops.getValue()}, function (data) {
                      ops.setValue(data);
                      me.$newForm.fireEvent("afterorgSelect",data,$obj);
                    });
                    break;
                  }
                  case 'department-user-selection': {
                    var multiple = $data.multiSelection == undefined ? false : $data.multiSelection;
                    PF.show('orgSelect', {multiple: multiple, config: config, value: ops.getValue()}, function (data) {
                      ops.setValue(data);
                      me.$newForm.fireEvent("afterorgSelect",data,$obj);
                    });
                    break;
                  }
                  case 'custom-selection': {
                    // let multi = $data.multiSelection == undefined ? false : $data.multiSelection;
                    let multi=!$data.singleSel;
                    PF.show('viewSelect', {id: $data.viewId, config: config, multi: multi}, function (data) {
                      if (data) {
                        ops.setValue(data);
                      } else {
                        ops.setValue();
                      }
                    });
                    break;
                  }
                  default: {
                    if($data.pageType=="page"){
                      config.setExtraFormField = function(d) {
                        me.extraFormField = d;
                      }
                      config.$obj = $obj;
                      config.ops = ops;
                      var params = {config:config,modelId:me.moduleId};
                      PF.dialog("mw-inner-page",{title:$data.pageTitle,width:$data.pageWidth,height:$data.pageHeight,
                        propsData:{pageId:objId,params:params}})
                    }
                  }
                }

              },
              hide: function (ops) {
                ops.setValue(value);
              }
            });
          })(this);
        }

        function fnDataItemResolver(dict, params, setDataItems) {
          if ($.isFunction(params) && !setDataItems) {
            setDataItems=params;
            params={};
          }
          me.mwApi.data.getDict(dict,params).then(function (data) {
            if (data.result && data.result.value) {
              let v = data.result.value.split(',');
              let v1 = [];
              let items = []
              v.forEach(function (d) {
                v1 = d.split('|');
                items.push({text: v1[1] || v1[0], value: v1[0]});
              });
              setDataItems(items);
            }
          });
        }

        function fnDataResolver(args) {
          if ('org-sel-default-value' === args.dataId) {
            me.mwApi.org.getCurrent(args.params).then(v => {
              args.fnSetData(v);
            })
          }

          if ('file-number-auto-generate' === args.dataId) {
            const {shouldGenerateFileNumber, getGenerateFileNumberParmas, beforeSetGeneratedFileNumber, setGeneratedFileNumber, updateRequestParams, afterGenerateFileNumber} = args;

            const formData = me.formData();

            if (shouldGenerateFileNumber(formData)) {
              const p = getGenerateFileNumberParmas(formData);
              me.mwApi.oasrv.generateAutoDocNumber(p).then(res => {
                if (res.success && res.result) {
                  me.extraFormField = beforeSetGeneratedFileNumber(res.result);
                  setGeneratedFileNumber(res.result);
                  updateRequestParams(params => {
                    me.mwLodash.assign(params.$form, me.formData());
                  });
                }
              }).then(afterGenerateFileNumber, afterGenerateFileNumber)
            } else {
              afterGenerateFileNumber();
            }
          }
        }

        var constantValues={
          taskId:me.taskId,
          appId:me.appId,
          businessId:me.businessId,
          draftsDocId: me.draftsDocId,
          taskData :me.taskData,
          extParams:me.extParams,
          flowKey:me.flowKey,
          moduleId:me.moduleId,
          extData:me.extData?me.extData:{},
          formId:me.formId,
          formKey:me.formKey,
          formVersion:me.formVersion,
          activity:me.activity,
          tempBusinessId:me.tempBusinessId,
          fieldMapping:me.fieldMapping,
          formName:me.formName,
          processDefinitionId:me.processDefinitionId,
          processDefinitionName:me.processDefinitionName
        }
        //console.log("activity:"+PF.encode(me.activity));
        $WR.ready(function (manager) {
          let content = con;
          content.hideHead = true;
          content.textMode = !me.editMode || me.isNotifyTask() || me.isReadOnlyTask();
          me.$emit("getTitle", content.name || content.title);
          manager.create({
            xtype: 'Form',
            constantValues:constantValues,
            resolvers: {
              fnDataResolver: fnDataResolver,
              fnDataItemResolver: fnDataItemResolver,
              fnImbeddedObjResolver: fnImbeddedObjResolver
            },
            $dd: content,
            $cc: me.authFields,
            user: me.expUser,
            values: formValue
          }, function (form) {
            var mark = (me.activity && me.activity.mark) ? me.activity.mark:"";
            var marks = mark ? mark.split(","):[];
            let rootCtx={
              "$userName":PF.userInfo.name,
              "$loginId":PF.userInfo.loginId,
              "$roleNames":PF.userInfo.roleNames,
              "$deptIdChain":PF.userInfo.deptIdChain,
              '$allIdentityRoleNames':PF.userInfo.allIdentityRoleNames,
              "$ext":formExpContext,
              '$flowMarks':marks
            };
            form.setExpressionContext(null,{},true);//不清楚为什么第一次设值设不进去，所以加第二次setExpressionContext yhq 2019/03/30
            form.setExpressionContext(null,rootCtx);
            me.$commentMinComponent = [];
            me.$newForm = form;
            form.on('afterRender', function () {
              if(me.propLoading){
                me.propLoading.close();
              }
              if (me.businessId) {
                if (me.type == 'module_flow') {
                  //解析获取所有办理意见控件的办理环节和办理意见类型
                  me.renderMinComment();
                }
                if(!me.lockSuccess && !form.notShowLockErrorMsg){
                  me.$newForm.fireEvent("showLockErrorMsg");
                  //被别人锁了
                  PF.message("warning",me.lockErrorMsg || $lang("文档由其他人编辑中"));
                }
              }
            });
            form.on('manualChange', function (a, b) {
              me.formValueChange = true;
            });

            let exportProperties=["action","taskId","businessId","draftsDocId","taskData","extParams","flowKey","moduleId",
              "formId","formKey","formVersion","activity","tempBusinessId","fieldMapping","formName",
              "processDefinitionId","processDefinitionName","dialog"];
            exportProperties.forEach(function(p){
              Object.defineProperty(me.$newForm,p,{
                get(){
                  return me[p];
                },
                set(v){
                  me[p]=v;
                }
              })
            });
            let exportFunctions=["startProcess","formActionComplete","refreshComment","setBtnLoading","setFlowAreaItems","setFlowAreaExtraFlows"];
            exportFunctions.forEach(function(f){
              me.$newForm[f]=me[f].bind(me);
            });
            me.$newForm.getExtForm = function () {
              let params = {};
              params.formData = _.assign({id: this.businessId}, this.formData())
              params.action = this.action;
              params.taskId = this.taskId;
              params.appId = this.appId;
              if (this.businessId) {
                params.businessId = this.businessId;
              }
              if (this.taskData) {
                params.taskData = this.taskData;
              }
              params.extParams=this.extParams;
              params.flowKey = this.flowKey;
              params.moduleId = this.moduleId;
              params.formId = this.formId;
              params.formKey = this.formKey;
              params.formVersion = this.formVersion;
              params.activity = this.activity;
              params.draftsDocId=this.draftsDocId;
              params.batchId = this.batchId;
              params.tempBusinessId = this.tempBusinessId;
              params.fieldMapping = this.fieldMapping;
              params.formName = this.formName;
              params.processDefinitionId = this.processDefinitionId;
              params.processDefinitionName = this.processDefinitionName;
              params.comment = this.commentId ? [{
                id: this.commentId,
                content: this.comment,
                category: this.commentCategory
              }] : [];

              params.startProcess = this.startProcess;
              params.formActionComplete = this.formActionComplete;
              params.refreshComment = this.refreshComment;
              params.setBtnLoading = this.setBtnLoading;
              params.btnDebounce = this.btnDebounce;

              params.formOpenSource = this.formOpenSource;
              return params;
            }.bind(me);

            me.$newForm.__originalExtForm=me;
            me.$emit("beforeRender",me.$newForm);
            me.$newForm.render($(me.$el.querySelector('.mw-form_id')));
          })
        })
      },
      //渲染表单上的意见
      renderMinComment(){
        let me = this;
        var cCategories=[],cTaskNames=[];
        //没有内置意见组件就不去请求后台
        if(me.$commentMinComponent.length===0) return;
        me.$commentMinComponent.forEach(v => {
          var commentConfig = v.$options.config.getConfig();
          if(commentConfig.typeMark=='2'){
            cTaskNames.push(commentConfig.activityName);
          }else{
            cCategories.push(commentConfig.activityName);
          }
        })
        var cCategory,cTaskName;
        if(cCategories.length>0){
          cCategory = cCategories.join(',');
        }
        if(cTaskNames.length>0){
          cTaskName = cTaskNames.join(',');
        }
        var qcp = {
          businessId: me.businessId,
          batchId:me.batchId,
          processDefinitionId: me.processDefinitionId
          ,category:cCategory,
          taskName:cTaskName
        }
        if(window.$Env && me.type == 'module_flow'){
          if($Env.formCommentNotShowHide || $Env.afterSaverRenderMinComment){
            qcp.notShowHide = true;
          }
          if($Env.formCommentDeptNameInsertUnitName){
            qcp.deptNameInsertUnitName = true;
          }
          if($Env.formCommentFilterWithdraw){
            qcp.formCommentFilterWithdraw = true;
          }
        }
        me.mwApi.business.queryCommentProcess(qcp).then(v => {
          let list = v.result;
          if (list) {
            me.$commentMinData=list;//为了$commentMinComponent重新渲染的时候直接从这里取值
            me.$commentMinComponent.forEach(v => {
              v.renderData(list);
            })
          }
        });
      },
      //打开表单读取配置渲染默认意见和表单按钮
      renderConfig() {
        let me = this;
        let params = {};
        params.moduleId = me.moduleId;
        params.appId = me.appId;
        params.taskId = me.taskId;

        if (me.taskId) {
          params.processDefinitionId = me.processDefinitionId;
          params.activityId = me.activityId;
        }
        params.processDefinitionKey = me.flowKey;
        params.formOpenSource = me.formOpenSource ;
        me.mwApi.config.flowConfig(params).then((data) => {
          me.activity = data.result.activity;
          me.processDefinitionId = me.activity.processDefinitionId;
          me.flowKey = me.activity.processDefinitionKey;
          me.processDefinitionName = me.activity.processDefinitionName;
          me.renderDefaultComment();
          let c = data.result.components;
          c.forEach(function (v) {
            //if (v.type == 'button') {
            v.loading=false;
            me.buttons.push(v);
            //}
          });
          if (!this.businessId)
            me.setInitValue();
        });
      },

      setInitValue() {
        let me = this;
        if (me.loaded || me.counter > 50) {
          return;
        }
        me.counter++;
        setTimeout(function () {
          if (me.$newForm) {
            me.loaded = true;
            me.$newForm.setExpressionContext({
              initflowid: me.processDefinitionId,
              initflowkey:me.flowKey,
              moduleId:me.moduleId,
              initflowname: me.processDefinitionName
            });
          } else {
            me.setInitValue();
          }
        }, 200);
      },

      //重新渲染表单按钮
      renderButton(params,callback) {
        let me = this;
        let oldAction={};
        me.buttons.forEach(v=>{
          oldAction[v.action]=v.loading;
        })

        me.mwApi.config.flowConfig(params).then((data) => {
          let btns = [];
          let c = data.result.components;
          c.forEach(function (v) {
            //if (v.type == 'button') {
            if(undefined==oldAction[v.action]){
              v.loading=false;
            }else{
              v.loading=oldAction[v.action];
            }
            v.name=$lang(v.name);
            btns.push(v);
            //}
          });
          me.buttons = btns;
          me.$newForm.fireEvent("afterrenderbutton",btns);
          me.$nextTick(function () {
            if (callback) {
              callback({taskId:me.taskId,businessId:me.businessId, batchId:me.batchId, draftsDocId:me.draftsDocId});
            }
          });
        });
      },
      isNotifyTask() {
        let me=this;
        return me.taskData && me.taskData.type==='0' && me.activity && me.activity.activityType !== 'circular'
      },
      isReadOnlyTask(){
        let me = this;
        return me.propReadOnly || me.readOnly || (me.activity && (me.activity.readOnly==='1' || me.activity.activityType === 'circular'))
      },
      //渲染默认意见
      renderDefaultComment() {
        var me = this;
        if (me.taskData) {
          var t = me.taskData;
          //知会任务非传阅节点不具有意见分类和默认意见
          var isNotifyTask = me.isNotifyTask();
          if (isNotifyTask) {
            return;
          }
        }
        me.commentCategory = me.activity.commentCategory;
        var moreCommentSwitch = me.activity.moreCommentSwitch; //允许添加多条意见
        if (me.taskId && moreCommentSwitch == '0') { //单条意见则默认显示已填写意见
          //默认只显示自己填写的意见，全权代办那里用到
          me.mwApi.business.listComment({taskId: me.taskId, isAgentRecord: 0,creatorId:PF.userInfo.inituserid}).then((data) => {
            var taskComments = data.result;
            if (taskComments.length > 0) {
              //陈彦宇修改  2018-6-25
              $.each(taskComments, function (index, el) {
                if (!el.contentType) {
                  me.comment = el.content;
                  me.commentId = el.id;
                  me.isUpdateComment = true;
                  return false;
                }
              })
              // me.comment = taskComments[0].content;
              // me.commentId = taskComments[0].id;
            } else {
              //默认意见
              if (me.activity.defaultComment != undefined) {
                me.comment = me.activity.defaultComment;
              }
            }
            if(me.$newForm){
              me.$newForm.fireEvent("renderdefaultcomment",{comment:(me.comment||""),commentId:me.commentId})
            }
          });
        } else {
          //默认意见
          if (me.activity.defaultComment != undefined) {
            me.comment = me.activity.defaultComment;
          }
          if(me.$newForm && me.comment){
            me.$newForm.fireEvent("renderdefaultcomment",{comment:(me.comment||""),commentId:me.commentId})
          }
        }
      },

      formData() {
        /**
         * @desc change by Grayson Wong, 业务需要额外提交一些与文号相关的参数
         * 文号控件输出数据保存到表单数据里, 流水号、年度、文件字控件本身可固定域名。
         * 后台接口可以直接从表单域中取得文号的 流水号、年度等信息.
         */
        return {...this.$newForm && this.$newForm.getValue() || {}, ...this.extraFormField};
        // return this.$newForm && this.$newForm.getValue();
      },

      updateFormData() {
        const {form: {data, ver}} = this,
          formData = this.formData();
        if (!_.isEqual(data, formData)) {
          this.form = {data: formData, ver: ver + 1};
        }
        return this;
      },
      //刷新意见列表组件
      refreshcommentComponent() {
        if (this.commentComponent.length > 0) {
          this.commentComponent.forEach(o => {
            o.refreshComment();
          })
        }
      },
      resetData(data,callback) {
        this.taskId = data.taskId;
        this.businessId = data.businessId;
        /*   this.$newform.setConstantValues({
             taskId:data.taskId,
             businessId:data.businessId
           })*/
        if (this.comment) {
          //刷新意见列表组件
          this.refreshcommentComponent();
        }
        //重新渲染按钮
        this.renderButton(data,callback);
      },

      reRender() {
        this.resetForm();
        let me = this;
        me.$nextTick(function () {
          me.commentId = $uuid();
          me.taskId = me.propTaskId;
          me.businessId = me.propBusinessId;
          me.moduleId = me.propModuleId;
          me.appId = me.propAppId;
          me.batchId = me.propBatchId;
          me.flowKey = me.propFlowKey;
          me.attachmentData = [];
          me.isCheck = me.propIsCheck;
          me.checkFromName = me.propcheckFromName;
          if (!me.businessId) {
            me.tempBusinessId = $uuid();
          } else {
            me.tempBusinessId = '';
          }
          this.renderForm();
        });
      },

      /*isValid(){
        this.$newForm
      },*/

      _doAction: _.debounce(
        async function (action) {
          if(typeof action==='function') {
            action.call(this);
          }else{
            PF.invokeFormAction(action, this.$newForm);
          }
        },
        1000,
        {leading: true, trailing: false}
      ),

      noticeButtonEvent(name) {
        this.components.forEach(c => {
          if (c && c.noticeButtonEvent) {
            c.noticeButtonEvent(name);
          }
        })
      },
      setBtnLoading(loading, name) {
        this.buttons.forEach(btn => {
          if (btn.action == name) {
            btn.loading = loading;
          }
        });
      },
      btnDebounce: _.debounce(function (callback) {
        let me = this;
        if (callback) {
          callback();
        }
      }, 1000, {
        'leading': true,
        'trailing': false
      }),
      formActionComplete($form,data) {
        this.$emit("formActionComplete",$form,data);
      },
      refreshComment(res) {
        var me = this;
        if (res.$comment && res.isAgentRecord != 1) {
          me.commentId = res.$comment[0].id;
          me.comment = res.$comment[0].content;
          me.isUpdateComment = true;
        }
        me.refreshcommentComponent();
      },
      startProcess: _.debounce(function (callback,action) {
      //startProcess(callback,action) {
        let params = {};
        let me = this;
        let {comment, commentId, commentCategory} = this;

        params.taskId = this.taskId;
        params.appId = this.appId;
        params.moduleId = this.moduleId;
        params.flowKey = this.flowKey;
        params.formId = this.formId;
        if(action){
          params.action=action;
        }
        if(me.forceModuleForm){
          params.coverFormData=me.forceModuleForm;
        }
        params.formVersion = this.formVersion;
        params.formKey = this.formKey;
        params.tempBusinessId = this.tempBusinessId;
        params.flowStarted=this.flowStarted;
        if(this.propDraftsDeptId){
          params.departmentId=this.propDraftsDeptId;
        }
        if (me.isReadOnlyTask() || me.isNotifyTask()) {
          params.$form={id: this.businessId}; //只读时不需要保存表单。
        }else{
          params.$form = _.assign({id: this.businessId}, this.formData());
        }
        params.$formFieldMapping = this.fieldMapping;
        //修改没有意见应该可以清空
        if (comment || (commentId && me.isUpdateComment)) {
          params.$comment = [{id: commentId, content: comment || "", category: commentCategory}];
        }
        params.flowAction = 'start';
        params.formOpenSource = this.formOpenSource;
        if(me.extParams && me.extParams.fullAuthType){
          params.fullAuthType = me.extParams.fullAuthType;
        }
        if(this.$newForm.fireEvent("beforesave",params,continuation.bind(this))===false){
          return callback(undefined,new Error("beforesave abort"));
        }
        function continuation(){
          this.mwApi.data.saveFormData(params).then((data) => {
            let p = {formOpenSource:params.formOpenSource};
            if (!me.taskId) {
              p.taskId = data.result.taskId;
              p.businessId = data.result.businessId;
              me.batchId = data.result.batchId;
              me.draftsDocId = data.result.draftsDocId;
              me.tempBusinessId = '';
              me.taskId=data.result.taskId;
              if(me.$newForm) me.$newForm.taskId=me.taskId;
            } else {
              if(data.result.taskId){
                p.taskId = data.result.taskId;
                p.businessId = data.result.businessId;
              }else{
                p.taskId = me.taskId;
                p.businessId = me.businessId;

              }
            }
            me.forceModuleForm=false;
            if(window.$Env && $Env.afterSaverRenderMinComment && me.type == 'module_flow'){
              me.renderMinComment();
            }
            /* me.params.tempBusinessId=me.tempBusinessId;
             me.params.businessId=me.businessId;*/
            this.$newForm.fireEvent("aftersave",data);
            me.$emit("updatedData", true);
            me.resetData(p,callback);
          }).catch((err) =>{
            me.$newForm.fireEvent("saveerror",err);
            callback(undefined,err)
          });
        }
        continuation.call(this);
      }, 1000, {
        'leading': true,
        'trailing': false
      }),
      getEditMode() {
        return this.editMode
      },
      setFlowAreaItems(items) {
        if (this.$refs.footerArea) {
          this.$refs.footerArea.footerItems=items;
        }
      },
      setFlowAreaExtraFlows(flows) {
        if (this.$refs.footerArea) {
          this.$refs.footerArea.extraFlows=flows;
        }
      },
      transFlowName(name) {
        if(!name)return "";
        if (name.indexOf('-') > 0) {
          let arr=name.split('-');
          return $lang(arr[0])+'-'+$lang(arr[1]);
        } else {
          return $lang(name);
        }
      },
      processRightCustomComp(){
        let me = this;
        if(me.rightCustomCompId && me.$refs.rightCustomCompDiv){
          let comp = PF.createVue({
            template:"<mw-inner-page :pageId='pageId' noWrap :params='params'></mw-inner-page>",
            data:{
              pageId:me.rightCustomCompId,
              params : {formObj:me}
            }
          });
          me.$nextTick(()=>{
            $(me.$refs.rightCustomCompDiv).html(comp.$mount().$el);
          })
        }
      },
      sidebarBtn(){
          if (this.showRightComment==true) {
              $(this.$refs.rightComment).css("right","-260px");
              this.showRightComment = false;
          }else {
              $(this.$refs.rightComment).css("right","0px");
              this.showRightComment = true;
          }
      },
    },
    watch: {
      propModuleId(newVal) {

      },
      propEditMode(newValue) {
        this.setEditMode(newValue);
      },
      extCustomCommentCompId(newVal){
        if(newVal){
          let me = this;
          let comp = PF.createVue({
            template:"<mw-inner-page :pageId='pageId' noWrap :params='params'></mw-inner-page>",
            data:{
              pageId:newVal,
              params : {formObj:me}
            }
          });
          me.$nextTick(()=>{
            $(me.$refs.extCustomCommentRef).html(comp.$mount().$el);
          })
        }
      }
    }
  }
</script>
<style scoped>
  .flow-area-on-top .vertical-flow-area{
    position:absolute;
    width:100%;
  }
  .flow-area-on-top .form_head_top{
    background: url(/assets/images/flow_form_top.jpg) no-repeat left top;
    background-size: cover;
  }
  .flow-area-on-top .mw-open-form{
    position:absolute;
    top:50px;
    width:100%;
  }
  .mw-form-right-con .right_panel_btn{
    position: absolute;
    z-index: 1010;
    width: 8px;
    height: 60px;
    background: #5b7d8c;
    top: 50%;
    left: -8px;
    margin: -15px 0 0 0;
    background: url("/assets/images/sider_btn_ico.png") no-repeat 2px center #5b7d8c;
    cursor: pointer;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .mw-form-left-con .split-right-con{
    position: fixed !important;
    overflow: inherit !important;
    right:-260px;
    top:50px;
    transition:.28s ease-out;
  }
</style>



// WEBPACK FOOTER //
// src/common/components/extend/form/src/main.vue